import { ProductFilterKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetProductFilter = () => {
  return useSetFilter(ProductFilterKey, 'productFilter', true);
};
